import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, Text, Box, Flex, Button, Modal, Input } from "samba-ui";
import styled from "styled-components";
import { DASHBOARD_DROPDOWN_OPTIONS } from "../constants";
import CampaignSelector from "./CampaignSelector";

const StyledInput = styled(Input)`
  width: 300px;
`;

const StyledBox = styled(Box)`
  width: 300px;
`;

const AddNewPeriscopeDashboardModal = ({ isOpen, onClose, onCreate }) => {
  const [name, setName] = useState(null);
  const [nameError, setNameError] = useState(null);
  const [periscopeId, setPeriscopeId] = useState(null);
  const [type, setType] = useState(null);
  const [selectedCampaignAndDate, setSelectedCampaignAndDate] = useState(null);
  const [salesforceId, setSalesforceId] = useState("");

  let disabled = nameError || !name || !periscopeId || !type;

  if (type && type.value !== "oem") {
    disabled = disabled || !selectedCampaignAndDate;
  }

  const onClickCreate = () => {
    const body = {
      name: name.trim(),
      periscopeId: periscopeId.trim(),
      salesforceId: salesforceId.trim(),
      type: type.value,
      ...selectedCampaignAndDate
    };
    onCreate(body);
  };

  const onCampaignSelector = campaignAndEndDate => {
    setSelectedCampaignAndDate(campaignAndEndDate);
  };

  const onNameChange = e => {
    const { value } = e.target;
    const regex = /^[a-zA-Z0-9\w _-]+$/;
    setName(value);
    if (value.match(regex)) {
      setNameError(null);
    } else {
      setNameError(
        "Enter alpanumeric values and the following special characters _, -, and space "
      );
    }
  };

  return (
    <Modal width={800} isOpen={isOpen} onRequestClose={onClose}>
      <Modal.Header borderColor="#d6d6d6 !important">
        Add new dashboard
      </Modal.Header>

      <Modal.Content>
        <Flex alignItems="center" justifyContent="space-between">
          <Text>Name:</Text>
          <StyledInput onChange={onNameChange} value={name} />
        </Flex>
        {nameError && (
          <Box textAlign="right">
            <Text color="red" fontSize={0} fontWeight={400}>
              {nameError}
            </Text>
          </Box>
        )}
        <Flex my={2} alignItems="center" justifyContent="space-between">
          <Text>Periscope id:</Text>
          <StyledInput
            onChange={e => setPeriscopeId(e.target.value)}
            value={periscopeId}
          />
        </Flex>
        <Flex my={2} alignItems="center" justifyContent="space-between">
          <Text>Salesforce id:</Text>
          <StyledInput
            onChange={e => setSalesforceId(e.target.value)}
            value={salesforceId}
          />
        </Flex>
        <Flex alignItems="center" justifyContent="space-between">
          <Text>Type:</Text>
          <StyledBox>
            <Dropdown
              options={DASHBOARD_DROPDOWN_OPTIONS.slice(1)}
              selected={type}
              onSelect={setType}
            />
          </StyledBox>
        </Flex>
        {name && periscopeId && type && type.value !== "oem" ? (
          <CampaignSelector
            selectedCampaignAndDate={onCampaignSelector}
            type={type.value}
          />
        ) : null}
      </Modal.Content>
      <Modal.Actions justifyContent="flex-end" borderColor="#d6d6d6 !important">
        <Flex>
          <Box mr={3}>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </Box>
          <Button variant="primary" onClick={onClickCreate} disabled={disabled}>
            Create New
          </Button>
        </Flex>
      </Modal.Actions>
    </Modal>
  );
};

AddNewPeriscopeDashboardModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired
};

export default AddNewPeriscopeDashboardModal;
